import { SESSION_STORAGE_KEYS } from '../constants';
import { CustomErrorClass, ErrorSeverity } from '../errors';
export class StorageService {
    parseSessionStorageValue(value) {
        if (!value)
            return null;
        try {
            return JSON.parse(value);
        }
        catch (e) {
            return null;
        }
    }
    setSession(sessionId, sessionStart) {
        const preservedHistory = this.getChatHistory() || {};
        if (!preservedHistory[sessionId]) {
            preservedHistory[sessionId] = {
                sessionStart,
                messages: [],
            };
            sessionStorage.setItem(SESSION_STORAGE_KEYS.CHAT_HISTORY, JSON.stringify(preservedHistory));
            return false;
        }
        return true;
    }
    setMessage(message, sessionId) {
        const chatHistory = this.getChatHistory() || {};
        if (chatHistory[sessionId]) {
            if (Array.isArray(chatHistory[sessionId].messages)) {
                chatHistory[sessionId].messages.push(message);
            }
            else {
                chatHistory[sessionId].messages = [message];
            }
        }
        else {
            const startDate = new Date();
            this.setSession(sessionId, startDate);
            this.setMessage(message, sessionId);
            return;
        }
        sessionStorage.setItem(SESSION_STORAGE_KEYS.CHAT_HISTORY, JSON.stringify(chatHistory));
    }
    getChatHistory() {
        const value = sessionStorage.getItem(SESSION_STORAGE_KEYS.CHAT_HISTORY);
        return this.parseSessionStorageValue(value);
    }
    setQuickReplyValue(reply, messageKey, sessionId) {
        const chatHistory = this.getChatHistory() || {};
        if (chatHistory[sessionId]) {
            if (Array.isArray(chatHistory[sessionId].messages)) {
                try {
                    chatHistory[sessionId].messages[messageKey].quick_replies.find(quickReply => quickReply.payload === reply).isSelected = true;
                    sessionStorage.setItem(SESSION_STORAGE_KEYS.CHAT_HISTORY, JSON.stringify(chatHistory));
                }
                catch (_a) {
                    throw new CustomErrorClass(ErrorSeverity.LogWarning, `Failed to save selected quick reply to history`, `reply: ${reply}, messageKey:${messageKey}`);
                }
            }
        }
    }
    overrideChatHistory(chatHistory) {
        sessionStorage.setItem(SESSION_STORAGE_KEYS.CHAT_HISTORY, chatHistory);
    }
}
//# sourceMappingURL=storage.service.js.map